export const MAX_EPISODE_BYTES = 500 * 1024 * 1024
export const SUPPORTED_EPISODE_EXTENSIONS = ["mp3", "m4a", "aac", "wav", "webm", "ogg", "flac"]

export const canResumeEpisodeUpload = (upload, file) => {
  if (!upload || !file) return false
  if (!["initialized", "uploading"].includes(upload.state)) return false

  return upload.filename === file.name && Number(upload.byte_size) === file.size
}

export const pendingEpisodeParts = (upload) => {
  const confirmed = new Set(upload.confirmed_parts.map((part) => Number(part.part_number)))
  const pending = []

  for (let number = 1; number <= Number(upload.total_parts); number += 1) {
    if (!confirmed.has(number)) pending.push(number)
  }

  return pending
}

export const episodeUploadProgress = (upload) => {
  if (!upload || Number(upload.byte_size) <= 0) return 0
  return Math.min(100, Math.round((Number(upload.confirmed_byte_size) / Number(upload.byte_size)) * 100))
}

export const episodeReviewUrl = (baseUrl, upload) => {
  if (upload?.state !== "completed" || !upload.podcast_item_id) return null

  return `${baseUrl.replace(/\/$/, "")}/${encodeURIComponent(upload.podcast_item_id)}`
}

export const sha256Hex = async (blob) => {
  const bytes = await blob.arrayBuffer()
  const digest = await crypto.subtle.digest("SHA-256", bytes)
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0")).join("")
}

export const confirmedEpisodePartsMatch = async (upload, file) => {
  for (const part of upload.confirmed_parts) {
    const partNumber = Number(part.part_number)
    const start = (partNumber - 1) * Number(upload.part_size)
    const chunk = file.slice(start, start + Number(part.byte_size))
    if (chunk.size !== Number(part.byte_size)) return false
    if (await sha256Hex(chunk) !== part.checksum_sha256) return false
  }

  return true
}
